import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export const JobTemplatesRoutes = {
    [`/job-templates/${hmapPathParamRegex}?tab`]: {
        "name": "appLayout.harriSH.access-portal.settings.jobTemplates",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./job-templates.module.js");
                }
            },
        ]
    },
    [`/ai-screening-questions/create/${hmapPathParamRegex}?brandId&templateId&isSettings`]: {
        "name": "appLayout.harriSH.access-portal.create-ai-screening-questions",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./job-templates.module.js");
                }
            },
        ]
    },
    "/ai-screening-questions/create?brandId&templateId&isSettings": {
        "name": "appLayout.harriSH.create-ai-screening-questions",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./job-templates.module.js");
                }
            },
        ]
    },
}